import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeycloakAngularModule } from 'keycloak-angular';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DragDropModule } from 'primeng/dragdrop';
import { MessageService } from 'primeng/api';
import { ListboxModule } from 'primeng/listbox';

import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ChipsModule } from 'primeng/chips';
import { MessageModule } from 'primeng/message';
import { DialogModule } from 'primeng/dialog';
import { AlertComponent } from './alert/alert.component';
import { NgxConditionBuilderModule } from './condition-builder/condition-builder.module';
import { YesNoDialogComponent } from './yes-no-dialog/yes-no-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownPipe } from './pipes/markdown.pipe';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';

import { FileUploadComponent } from './components/forms/file-upload/file-upload.component';
import { SelectShoppingCartComponent } from './select-shopping-cart/select-shopping-cart.component';
import { RequiredLabelPipe } from './pipes/required-label.pipe';

@NgModule({
  declarations: [
    AlertComponent,
    YesNoDialogComponent,
    MarkdownPipe,
    BreadcrumbComponent,
    FileUploadComponent,
    SelectShoppingCartComponent,
    RequiredLabelPipe,
  ],
  imports: [
    CommonModule,
    FileUploadModule,
    ToastrModule.forRoot({
      positionClass: 'toast-center-center',
    }), // ToastrModule added
    ToastModule,
    /* PrimeNG modules */
    ButtonModule,
    DynamicDialogModule,
    MultiSelectModule,
    BreadcrumbModule,
    DialogModule,
    CardModule,
    ListboxModule,
    TranslateModule

  ],
  providers: [DialogService, MessageService],
  exports: [
    FileUploadComponent,
    RequiredLabelPipe,
    MarkdownPipe,
    DialogModule,
    BrowserAnimationsModule,
    KeycloakAngularModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule,
    SelectShoppingCartComponent,
    ListboxModule,

    AlertComponent,

    /* PrimeNG modules */
    AccordionModule,
    ButtonModule,
    CalendarModule,
    CheckboxModule,
    DragDropModule,
    DropdownModule,

    DynamicDialogModule,
    InputNumberModule,
    InputTextModule,
    MenuModule,
    TieredMenuModule,
    MessageModule,
    MultiSelectModule,
    ProgressBarModule,
    RadioButtonModule,
    TableModule,
    TabViewModule,
    ChipsModule,
    TranslateModule,

    NgxConditionBuilderModule,

    BreadcrumbComponent,
    CardModule,
  ],
})
export class SharedModule {}
